/* cleo — interactions: scroll reveal, bundle selector, sticky ATC, FAQ, ship bar */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.cleo-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cleo-in'); });
      return;
    }
    // Reveal anything already in (or near) the viewport right away. This handles
    // tall above-the-fold sections whose intersection ratio would never hit a
    // higher threshold — the cause of the "blank section" bug.
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.95) {
        el.classList.add('cleo-in');
      }
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cleo-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (el) { if (!el.classList.contains('cleo-in')) io.observe(el); });
    // Safety net: never leave content invisible, whatever happens.
    setTimeout(function () { els.forEach(function (el) { el.classList.add('cleo-in'); }); }, 2500);
  }

  /* ---------- money ---------- */
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- bundle selector ---------- */
  function initBundle() {
    var root = document.querySelector('[data-cleo-product]');
    if (!root) return;
    var variants;
    try { variants = JSON.parse(root.querySelector('[data-cleo-variants]').textContent); }
    catch (e) { return; }

    var idInput = root.querySelector('[data-cleo-id]');
    var priceEl = root.querySelector('[data-cleo-price]');
    var bundleEls = root.querySelectorAll('.cleo-bundle');
    var sizeEls = root.querySelectorAll('.cleo-size__btn');
    var submit = root.querySelector('[data-cleo-submit]');

    var state = {
      qty: root.getAttribute('data-default-qty') || (bundleEls[0] && bundleEls[0].getAttribute('data-qty')),
      size: sizeEls[0] && sizeEls[0].getAttribute('data-size')
    };

    function match() {
      return variants.find(function (v) {
        return v.option_qty === state.qty && v.option_size === state.size;
      });
    }

    function sync() {
      var v = match();
      bundleEls.forEach(function (b) { b.classList.toggle('is-selected', b.getAttribute('data-qty') === state.qty); });
      sizeEls.forEach(function (s) { s.classList.toggle('is-selected', s.getAttribute('data-size') === state.size); });

      // reflect the chosen size + bundle on the sticky bar (independent of variant match)
      var ssize = document.querySelector('[data-cleo-sticky-size]');
      if (ssize && state.size) ssize.textContent = state.size;
      var sqty = document.querySelector('[data-cleo-sticky-qty]');
      if (sqty && state.qty) sqty.textContent = state.qty;

      if (!v) {
        if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      // mirror price to the sticky bar
      var sp = document.querySelector('[data-cleo-sticky-price]');
      if (sp) sp.textContent = money(v.price);
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
    }

    bundleEls.forEach(function (b) {
      b.addEventListener('click', function () { state.qty = b.getAttribute('data-qty'); sync(); });
    });
    sizeEls.forEach(function (s) {
      s.addEventListener('click', function () { state.size = s.getAttribute('data-size'); sync(); });
    });
    sync();
  }

  /* ---------- sticky add-to-cart ---------- */
  function initSticky() {
    var bar = document.querySelector('.cleo-sticky-atc');
    // Anchor visibility to the MAIN Add to Cart button, not the whole buy box, so the
    // bar appears as soon as that button is off-screen (and shows immediately on mobile,
    // where the button sits below the first screen).
    var mainBtn = document.querySelector('[data-cleo-submit]') ||
                  document.querySelector('[data-cleo-atc-anchor]');
    if (!bar || !mainBtn) return;

    function show(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { show(!e.isIntersecting); });
      }, { threshold: 0 });
      io.observe(mainBtn);
    } else {
      var onScroll = function () {
        var r = mainBtn.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        show(r.bottom < 0 || r.top > vh);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    }

    // sticky button submits the real form
    var stickyBtn = bar.querySelector('[data-cleo-sticky-submit]');
    var form = document.querySelector('[data-cleo-product] form');
    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    document.querySelectorAll('.cleo-faq__q').forEach(function (q) {
      q.addEventListener('click', function () {
        q.closest('.cleo-faq__item').classList.toggle('is-open');
      });
    });
  }

  /* ---------- cart free-shipping bar (dynamic recompute) ---------- */
  function initShipBar() {
    var bar = document.querySelector('[data-cleo-shipbar]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10); // cents
    var total = parseInt(bar.getAttribute('data-total'), 10);         // cents
    var fill = bar.querySelector('.cleo-shipbar__fill');
    var text = bar.querySelector('.cleo-shipbar__text');
    var pct = Math.min(100, Math.round((total / threshold) * 100));
    if (fill) fill.style.width = pct + '%';
    if (text) {
      if (total >= threshold) {
        text.innerHTML = "&#127881; You've unlocked <b>free shipping!</b>";
      } else {
        text.innerHTML = "You're <b>$" + ((threshold - total) / 100).toFixed(2) +
          "</b> away from free shipping";
      }
    }
  }

  /* ---------- product gallery (swipe + thumbnails) ---------- */
  function initGallery() {
    var galleries = document.querySelectorAll('[data-cleo-gallery]');
    Array.prototype.forEach.call(galleries, function (g) {
      var track = g.querySelector('[data-cleo-track]');
      if (!track) return;
      var slides = track.querySelectorAll('[data-cleo-slide]');
      if (slides.length < 2) return;
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-cleo-thumb]'));
      var tw = g.querySelector('[data-cleo-thumbs]');

      function setActive(i) {
        thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
        if (tw && thumbs[i]) {
          var t = thumbs[i];
          tw.scrollTo({ left: t.offsetLeft - (tw.clientWidth / 2) + (t.clientWidth / 2), behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      function goTo(i, smooth) {
        var slide = slides[i];
        if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: (smooth && !reduce) ? 'smooth' : 'auto' });
        setActive(i);
      }

      // thumbnail click -> swap main image
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          goTo(parseInt(t.getAttribute('data-cleo-thumb'), 10) || 0, true);
        });
      });

      // scroll/swipe -> sync active thumbnail
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i < 0) i = 0;
          if (i > slides.length - 1) i = slides.length - 1;
          setActive(i);
        });
      });

      // desktop mouse drag-to-scroll
      var down = false, startX = 0, startScroll = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; startX = e.clientX; startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        track.scrollLeft = startScroll - (e.clientX - startX);
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
        goTo(Math.round(track.scrollLeft / track.clientWidth), true);
      });
    });
  }

  function init() {
    document.documentElement.classList.add('cleo-js');
    initReveal(); initBundle(); initSticky(); initFaq(); initShipBar(); initGallery();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
